import Certifications from "~/components/footer/Certifications"
import Divider from "~/components/footer/Divider"
import Help from "~/components/footer/Help"
import Images from "~/components/footer/Images"
import Institutional from "~/components/footer/Institutional"
import Logo from "~/components/footer/Logo"
import PaymentMethods from "~/components/footer/PaymentMethods"
import Security from "~/components/footer/Security"
import Service from "~/components/footer/Service"
import Social from "~/components/footer/Social"
import type { FooterProps } from "~/components/footer/types"
import Newsletter from "~/components/footer/Newsletter"
import Image from "~/components/ui/Image"
import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco"
export default function Footer(
    {
        background,
        logo,
        newsletter,
        institutional,
        service,
        help,
        payments,
        social,
        certifications,
        security,
        informations,
        images,
        isMobile,
    }: SectionProps<typeof loader>,
) {
    return (
        <footer className='w-full px-3 py-10 text-white bg-black lg:bg-center lg:bg-cover overflow-x-hidden relative'>
            {background && !isMobile && (
                <Image
                    className='w-full absolute top-0 left-0 lg:h-full lg:object-cover'
                    src={background.image}
                    alt={background.alt}
                    width={1920}
                    height={522}
                    loading='lazy'
                />
            )}

            <div className='flex flex-col gap-5 relative'>
                {logo && isMobile && (
                    <div className='-mx-3 -mt-10 relative'>
                        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                            <Logo {...logo} />
                        </div>

                        {background && isMobile && (
                            <Image
                                src={background.image}
                                alt={background.alt}
                                width={1920}
                                height={522}
                                loading='lazy'
                            />
                        )}
                    </div>
                )}

                <div className='flex lg:flex-row flex-col justify-between w-full max-w-[1770px] lg:divide-y-0 divide-y divide-solid divide-[#201f1f] mx-auto'>
                    {logo && !isMobile && (
                        <div className='shrink-0 mb-8 lg:mb-4 lg:mr-[3%] xl:mr-[7.5%] border-none flex lg:mt-32 xl:mt-0 xl:items-center justify-center'>
                            <Logo {...logo} />
                        </div>
                    )}

                    {isMobile
                        ? (
                            <>
                                {newsletter && <Newsletter {...newsletter} />}
                                {institutional && <Institutional {...institutional} isMobile />}
                                {service && <Service {...service} isMobile />}
                                {help && <Help {...help} isMobile />}
                                {payments && <PaymentMethods {...payments} isMobile />}
                                {social && <Social {...social} isMobile />}
                                {certifications && <Certifications {...certifications} isMobile />}
                                {security && <Security {...security} isMobile />}
                            </>
                        )
                        : (
                            <div className='w-full flex justify-between xl:mr-8'>
                                {institutional && (
                                    <div className='max-w-[25%]'>
                                        <Institutional {...institutional} isMobile={false} />
                                    </div>
                                )}

                                {service && (
                                    <div className='max-w-[25%]'>
                                        <Service {...service} isMobile={false} />
                                    </div>
                                )}

                                {(help || payments) && (
                                    <div className='max-w-[25%] space-y-5'>
                                        {help && <Help {...help} isMobile={false} />}
                                        {payments && (
                                            <PaymentMethods {...payments} isMobile={false} />
                                        )}
                                    </div>
                                )}

                                {(social || certifications || security) && (
                                    <div className='max-w-[25%] space-y-5'>
                                        {social && <Social {...social} isMobile={false} />}

                                        <div className='flex max-[1200px]:flex-wrap gap-3'>
                                            {certifications && (
                                                <Certifications
                                                    {...certifications}
                                                    isMobile={false}
                                                />
                                            )}

                                            {security && (
                                                <Security {...security} isMobile={false} />
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                </div>

                {informations && (
                    <>
                        <Divider />

                        <div
                            className='flex flex-col mx-6 text-center'
                            dangerouslySetInnerHTML={{ __html: informations }}
                        />
                    </>
                )}

                {images && (
                    <>
                        <Divider />
                        <Images {...images} />
                    </>
                )}
            </div>
        </footer>
    )
}
export const loader = (props: FooterProps, _request: Request, ctx: FnContext) => {
    return {
        ...props,
        isMobile: ctx.device !== 'desktop',
    }
}
